import { getAccessToken as r } from "@liff/store";

function o() {
  return !!r();
}

export { o as isLoggedIn };